import { Controller } from "@hotwired/stimulus"

// La série n'apparaît qu'à partir de la 2nde/Lower Sixth — corpus *Passage de
// classe*, écran « Choix de série » : « obligatoire à partir de la 2ⁿᵈᵉ et de
// Lower Sixth, interdit avant ».
//
// ⚠️ **Même piège que `g4l-enrolment`, même remède.** Masquer sans désactiver
// laisse un champ (ici la sélection de série) atteindre le serveur alors que
// l'écran prétendait ne pas le demander — et `ClassTransition` le REFUSERAIT
// (`forbidden_for_class`), pour un motif que l'utilisateur n'a jamais vu
// apparaître à l'écran. On désactive, pas seulement on masque.
export default class extends Controller {
  static targets = ["classSelect", "seriesSection"]
  static values = { requiresSeries: Array }

  connect() {
    this.apply()
  }

  apply() {
    const required = this.requiresSeriesValue.includes(this.classSelectTarget.value)
    this.seriesSectionTarget.classList.toggle("hidden", !required)
    this.seriesSectionTarget.querySelectorAll("input, select").forEach((field) => {
      field.disabled = !required
    })
  }
}
